import {mapGetters, mapActions, mapMutations} from 'vuex';
import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
import { getSessionStorage } from '../../utilities/nojq/_localstorage.js';

export default {
    name: 'mvtMapLayers',
    inject: ['$eventBus'],
    props: {
        getSchoolPins: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            showSchoolFilter: false,
            schoolUnrated: [
                {
                    text: ' Include N/A rating',
                    value: 1,
                    defaultValue: 0
                }
            ],
            scoreList: [
                {
                    text: '1+',
                    value: 1,
                },
                {
                    text: '2+',
                    value: 2,
                },
                {
                    text: '3+',
                    value: 3,
                },
                {
                    text: '4+',
                    value: 4,
                },
                {
                    text: '5+',
                    value: 5,
                },
                {
                    text: '6+',
                    value: 6,
                },
                {
                    text: '7+',
                    value: 7,
                },
                {
                    text: '8+',
                    value: 8,
                },
                {
                    text: '9+',
                    value: 9,
                },
                {
                    text: '10',
                    value: 10,
                },

            ]
        };
    },
    components: {
        mvtCheckbox,
        mvtRadio
    },
    computed: {
        ...mapGetters('glb', ['glb', 'mapType', 'mapDetails', 'getSelectedPoi']),
        ...mapGetters('msp', ['msp']),
        schoolHigh: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolHigh');
            },
            get: function() {
                return this.msp.filter.schoolHigh;
            }
        },
        schoolMiddle: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolMiddle');
            },
            get: function() {
                return this.msp.filter.schoolMiddle;
            }
        },
        schoolPre: {
            set: function(val) {
                this._applyFilter({
                    schoolPre: val,
                    schoolElementary: val
                });
            },
            get: function() {
                return this.msp.filter.schoolPre;
            }
        },
        schoolPublic: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolPublic');
            },
            get: function() {
                return this.msp.filter.schoolPublic;
            }
        },
        schoolCharter: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolCharter');
            },
            get: function() {
                return this.msp.filter.schoolCharter;
            }
        },
        schoolPrivate: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolPrivate');
            },
            get: function() {
                return this.msp.filter.schoolPrivate;
            }
        },
        schoolMinRate: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolMinRate');
            },
            get: function() {
                return this.msp.filter.schoolMinRate;
            }
        },
        schoolIncludeUnrated: {
            set: function(val) {
                this._updateFilterByKey(val, 'schoolIncludeUnrated');
            },
            get: function() {
                return this.msp.filter.schoolIncludeUnrated;
            }
        }
    },
    methods: {
        ...mapActions('msp', ['applyTextSearch', 'applyFilterData']),
        ...mapMutations('glb', ['updateMapType', 'updateMapDetails', 'updateSelectedPoi']),
        toggleMapSchools() {
            this.showSchoolFilter = !this.showSchoolFilter;
            if(!this.showSchoolFilter){
                this._applyFilter({
                    schoolPre: 0,
                    schoolElementary: 0,
                    schoolMiddle: 0,
                    schoolHigh: 0,
                    schoolPublic: 0,
                    schoolCharter: 0,
                    schoolPrivate: 0
                });
            } else {
                this._applyFilter({
                    schoolPublic: 1
                });
            }
        },
        closePopup() {
            this.$emit('closePopup');
        },
        switchMapType(mapType) {
            if(this.mapType !== mapType){
                this.updateMapType({mapType});
                this.$emit('switchMap', mapType);
            }
        },
        switchLayer(layer) {
            if (this.mapDetails !== layer) {
                this.updateMapDetails({mapDetails: layer});
                this.$emit('switchLayer', layer);
            } else {
                this.updateMapDetails({mapDetails: ''});
                this.$emit('switchLayer', '');
            }
        },
        schoolFilter(filterType) {
            this[filterType] = Math.abs(this[filterType] - 1);
            let filterData = {};
            filterData[filterType] = this[filterType];
            this._applyFilter(filterData);
        },
        async _applyFilter(data) {
            const that = this;
            this.applyFilterData(data).then(url => {
                if(window.location.pathname !== url){
                    if(that.getSchoolPins){
                        that.$emit('updateSchoolsOnMap', url);
                    }
                    else{
                        that.$router.push(url);
                    }
                }
            });
        },
        _updateFilterByKey: function(context, key) {
            var param = {};
            param[key] = context && context.value || context;
            param && this._applyFilter(param);
        },
        updatePoi(poi) {
            let selectedPoiList = this.getSelectedPoi.includes(poi) ? this.getSelectedPoi.filter(selectedPoi => selectedPoi !== poi) : [...this.getSelectedPoi, poi];
            this.updateSelectedPoi(selectedPoiList);
        }
    },
    mounted(){
        this.showSchoolFilter = !!(
            this.schoolPre ||
            this.schoolElementary ||
            this.schoolMiddle ||
            this.schoolHigh ||
            this.schoolPublic ||
            this.schoolCharter ||
            this.schoolPrivate ||
            (this.schoolMinRate > 1)
        );
        var mapType = getSessionStorage('map.mapType');
        var mapDetails = getSessionStorage('map.mapDetails');
        mapType = isNaN(+mapType) ? mapType : +mapType;
        this.updateMapType({mapType});
        this.updateMapDetails({mapDetails});
    },
};
